import React, { useEffect, useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import { useLocation } from "react-router-dom";
import HeadingComponent from "components/headingComponent";
import ViewDataComponent from "components/viewData";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import { query, collection, getDocs } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import "./index.css";

function StudentsDetailView() {
  const [admissionInfoView, setAdmissionInfoView] = useState([]);
  const [personalInfoView, setPersonalInfoView] = useState([]);
  const [courseInfoView, setCourseInfoView] = useState([]);
  const [paymentInfoView, setPaymentInfoView] = useState([]);
  const [otherInfoView, setOtherInfoView] = useState([]);
  const location = useLocation();

  // MARK: fetch course API
  async function fetchCoursesApi() {
    const batchFunction = await fetchBatchesApi();

    let q = query(collection(dbFirestore, TableName.courses));

    const querySnapshot = await getDocs(q);

    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    const courseObject = array.find(
      (course) => course.id === location.state.selected_course_id
    );

    setCourseInfoView([
      {
        label: "Course Selection:",
        data: courseObject.name,
        class: "table__column__uppercase ms-0",isShown: false
      },
      {
        label: "Batch Selection:",
        data: batchFunction["batch_name"],
        class: "table__column__capital ms-0",isShown: false
      },
      {
        label: "Demo Date:",
        data: demoDateTimestamp(),
         class: "ms-0",isShown: false
      },
    ]);
  }

  // MARK: fetch batches API
  async function fetchBatchesApi() {
    let q = query(collection(dbFirestore, TableName.batches));

    const querySnapshot = await getDocs(q);

    const batchArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    const batchObject = batchArray.find(
      (batch) => batch.firebase_id === location.state.batch_firebase_id
    );
    return batchObject;
  }

  useEffect(() => {
    if (location.state) {
      fetchCoursesApi();
      fetchBatchesApi();
      getPaymentDurationData();

      setAdmissionInfoView([
        {
          label: "Admission number:",
          data: location.state.admission_no,
          class: "ms-0",isShown: false
        },
        {
          label: "Admission Date:",
          data: admissionDateTimestamp(),
          class: "ms-0",isShown: false
        },
        {
          label: "Student ID:",
          data: location.state.id,
          class: "ms-0",isShown: true
        },
      ]);

      setAdmissionInfoView([
        {
          label: "Admission number:",
          data: location.state.admission_no,
          class: "ms-0",isShown: false
        },
        {
          label: "Admission Date:",
          data: admissionDateTimestamp(),
          class: "ms-0",isShown: false
        },
        {
          label: "Student ID:",
          data: location.state.id,
          class: "ms-0",isShown: true
        },
      ]);

      setPersonalInfoView([
        { label: "Student name:", data: location.state.name, class: "table__column__capital ms-0" ,isShown: false},
        {
          label: "Date of Birth:",
          data: birthDateTimestamp(),
          class: "ms-0",isShown: false
        },
        { label: "Email:", data: location.state.email ? location.state.email : "Null", class: "table__column__lowercase ms-0",isShown: false },
        {
          label: "Contact number:",
          data: location.state.contact_no, class: "ms-0",isShown: false
        },
        {
          label: "Father/Husband name:",
          data: location.state.father_husband_name, class: "table__column__capital ms-0",isShown: false
        },
        {
          label: "Father/Husband contact no. :",
          data: location.state.father_husband_no, class: "ms-0",isShown: false
        },
        {
          label: "Marital status:",
          data: location.state.selected_marital_status ? location.state.selected_marital_status : "null", class: "table__column__capital ms-0",isShown: false
        },
        { label: "Address:", data: location.state.address ? location.state.address : "null", class: "table__column__capital ms-0",isShown: false },
      ]);

      setOtherInfoView([
        {
          label: "Reference:",
          data: location.state.reference ? location.state.reference : "null",
          class: "table__column__capital ms-0",isShown: false
        },
        {
          label: "Previous Visa Refusal:",
          data: location.state.selected_visa_refusal ? location.state.selected_visa_refusal : "null",
          class: "table__column__capital ms-0",isShown: false
        },
        {
          label: "Description:",
          data: location.state.refusal_reason ? location.state.refusal_reason : "null",
          class: "table__column__capital ms-0",isShown: false
        },
      ]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: fetch payment duration data
  async function getPaymentDurationData() {
    let q = query(collection(dbFirestore, TableName.paymenyDuration));

    const querySnapshot = await getDocs(q);

    const paymentArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    const paymentObject = paymentArray.find(
      (payment) => payment.id === location.state.selected_payment_duration_id
    );
    setPaymentInfoView([
      {
        label: "Payment Duration:",
        data: paymentObject["name"],isShown: false
      },
      {
        label: "Batch Fee Per Month:",
        data: location.state.batch_fee_num,isShown: false
      },
    ]);
  }

  // MARK: admission date format
  function admissionDateTimestamp() {
    if (location.state.rejoin_date === "Invalid date") {
      return <Moment format={Dateformat.DDMMYYYY}>{location.state.admission_date}</Moment>
    }
    
    if(location.state.rejoin_date) {
      return <Moment format={Dateformat.DDMMYYYY}>{location.state.rejoin_date}</Moment>
    } else if (location.state.admission_date)  {
      return <Moment format={Dateformat.DDMMYYYY}>{location.state.admission_date}</Moment>
    } else {
      return "NA"
    }

  }


  // MARK: demo date format
  function demoDateTimestamp() {
    return (
      location.state.demo_date ?
        <Moment format={Dateformat.DDMMYYYY}>
          {location.state.demo_date}
        </Moment> : "Null"
    );
  }

  // MARK: birth date format
  function birthDateTimestamp() {
    return <Moment format={Dateformat.DDMMYYYY}>{location.state.dob}</Moment>;
  }

  // MARK: Use Layout Method
  useLayoutEffect(() => {
    document.title = CommonHeadings.studentView;
  }, []);

  return (
    <div className="modules__main__div">
      <div className="col-12">
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 mt-5">
            <div className="col">
              <div className="card card-column ">
                {admissionInfoView.length > 0 && (
                  <HeadingComponent
                    headingName="Admission Info"
                    classname="mb-3 mt-5 text-center"
                  />
                )}
                {admissionInfoView.length > 0 &&
                  admissionInfoView.map((data) => (
                    <ViewDataComponent
                      key={data.label}
                      label={data.label}
                      data={data.data}
                      isShown={data.isShown}
                      class={data.class}
                    />
                  ))}
              </div>
            </div>

            <div className="col">
              <div className="card card-column" style={{height: "16.75rem"}}>
                {paymentInfoView.length > 0 && (
                  <HeadingComponent
                    headingName="Payment Info"
                    classname="mb-3 mt-5 text-center"
                  />
                )}
                {paymentInfoView.length > 0 &&
                  paymentInfoView.map((data) => (
                    <ViewDataComponent
                      key={data.label}
                      label={data.label}
                      data={data.data}
                      isShown={data.isShown}
                      class={data.class}
                    />
                  ))}
              </div>
            </div>

          </div>

          <div className="card mt-5 card-column ">
            {personalInfoView.length > 0 && (
              <HeadingComponent
                headingName="Personal Info"
                classname="mb-3 mt-5 text-center"
              />
            )}
            {personalInfoView.length > 0 &&
              personalInfoView.map((data) => (
                <ViewDataComponent
                  key={data.label}
                  label={data.label}
                  data={data.data}
                  isShown={data.isShown}
                  class={data.class}
                />
              ))}
          </div>

          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 mt-5">
            <div className="col">
              <div className="card card-column ">
            {courseInfoView.length > 0 && (
              <HeadingComponent
                headingName="Course Info"
                classname="mb-3 mt-5 text-center"
              />
            )}
            {courseInfoView.length > 0 &&
              courseInfoView.map((data) => (
                <ViewDataComponent
                  key={data.label}
                  label={data.label}
                  data={data.data}
                  isShown={data.isShown}
                  class={data.class}
                />
              ))}
          </div>
          </div>
          <div className="col mt-5 mt-sm-5 mt-md-5 mt-lg-auto">
          <div className="card card-column ">
            {otherInfoView.length > 0 && (
              <HeadingComponent
                headingName="Other Info"
                classname="mb-3 mt-5 text-center"
              />
            )}
            {otherInfoView.length > 0 &&
              otherInfoView.map((data) => (
                <ViewDataComponent
                  key={data.label}
                  label={data.label}
                  data={data.data}
                  isShown={data.isShown}
                  class={data.class}
                />
              ))}
          </div>
          </div>
          </div>

      </div>
    </div>
  );
}

export default StudentsDetailView;
